import type {CheckoutPerRoomService} from "@/scopes/checkout/domain/types";
import {produce} from "immer";

interface PerRoomServicePayload {
  roomId: string;
  value: string;
}

export function updatePerRoomService(payload: PerRoomServicePayload) {
  return produce((service: CheckoutPerRoomService) => {
    service.rooms[payload.roomId].selectedValue = payload.value;
  });
}
